import { all } from "redux-saga/effects";
import {watchgetApplicationDetails} from "./saga/generalSaga";
import { watchgetLanguageDetails, watchgetTokenDetails, watchgetUserCountryDetails } from "./saga/loginSaga";

export function* rootSaga() {
  yield all([
    watchgetApplicationDetails(),
    watchgetLanguageDetails(),
    watchgetTokenDetails(),
    watchgetUserCountryDetails()
  ]);
}
